import NextImage from 'next/image';

import { Image as ImageComponent } from '@components/Image';

import { WagtailImage } from '@/types';
import RawHtml from '@components/RawHtml';

type Member = {
  image: WagtailImage | null;
  name: string;
  position: string;
};

type Props = {
  blocktitle?: string;
  description?: string;
  members: Member[];
};

function Team(props: Props) {
  const { blocktitle, description, members } = props;

  return (
    <div className='streamfield teamblock'>
      <div className='container'>
        {(blocktitle || description) && (
          <div className='teamblock__header'>
            {blocktitle && <h2 className='teamblock__title'>{blocktitle}</h2>}
            {description && <p className='teamblock__description'>{description}</p>}
          </div>
        )}
        <div className='teamblock__wrapper'>
          {members.map((member, index) => (
            <div className='teamblock__member' key={index}>
              {member.image ? (
                <ImageComponent
                  image={member.image}
                  className='teamblock__member-image'
                  spec='fill-300x300'
                  style={{ width: '200px', height: '200px' }}
                />
              ) : (
                <NextImage
                  src='/team-placeholder.svg'
                  alt=''
                  width={200}
                  height={200}
                  className='teamblock__member-image'
                />
              )}
              <p className='teamblock__member-name'>{member.name}</p>
              {member.position && (
                <RawHtml className='teamblock__member-position' html={member.position} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Team;
